export const GoParametersValidationMessages = {
    exclusiveStationClassTypeInvalid:
        'Exclusive station class option is not valid for the selected location type.',
    dataDirectionTypeRequired:
        'Data direction type is required for this application type.',
    heightToTipRequired: 'Height to tip is required for this application type.',
    antennaHeightUnitTypeRequired:
        'Height to tip unit is required for this application type.',
    fixedErpRequired: 'Fixed ERP is required for this application type.',
    asrInvalid: 'ASR number is invalid.',
} as const;
